import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { MenuItem } from 'primeng/api'
import { CustomNavMenuService, DynamicRoutesService } from '@dot-it/jml-lib'

@Component({
  selector: 'jml-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  model2: Observable<MenuItem[]>

  constructor(
    private customNavMenuService: CustomNavMenuService,
    private dynamicRoutesService: DynamicRoutesService
  ) {}

  ngOnInit(): void {
    // this should be done in the login process (store) - but would be blow up complexity unreasonably.
    this.dynamicRoutesService.updateRoutes()

    this.model2 = this.customNavMenuService.getCustomMenuItemTree()
  }
}
